export const esLang = {
  languageKey: 'es',
  translates: {
    IDENTITY_DOCUMENT_TYPE: 'Tipo de documento',
    IDENTITY_DOCUMENT_DNI: 'DNI',
    IDENTITY_DOCUMENT_NIE: 'NIE',
    IDENTITY_DOCUMENT_CIF: 'CIF',
    IDENTITY_DOCUMENT_SPANISH_PASSPORT: 'Pasaporte Español',
    IDENTITY_DOCUMENT_FOREIGN_PASSPORT: 'Pasaporte Extranjero',
    IDENTITY_DOCUMENT_OTHER: 'Otros',
    IDENTITY_DOCUMENT_NOT_AVAILABLE: 'No consta',
    IDENTITY_DOCUMENT_NUMBER: 'Número de identidad',
    nif: 'NIF/NIE/Pasaporte/CIF',
  },
};
